import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Self-hosted variable font: no third-party request, no render-blocking
// stylesheet, and no font-src exception needed in the Content Security Policy.
import '@fontsource-variable/inter';
import './index.css';

import App from './App.jsx';
import { ThemeProvider } from './lib/ThemeProvider.jsx';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    {/* Outside the router so the theme survives navigation and is shared by both
        the storefront and the admin area. */}
    <ThemeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);
